<template>
    <dash
        icon="fa fa-graduation-cap"
        titulo="BASE DE CONHECIMENTO"
        @click.native="$router.push({ name: 'BaseConhecimento' })"
        :mostrarQtd="false"
        :loading="loading"
    ></dash>
</template>

<script>
import Dash from '@/shared/components/DashComponent'

export default {
    props: {
        qtd: {
            type: Number
        },

        loading: {
            type: Boolean
        }
    },

    components: {
        Dash
    },

    data() {
        return {}
    }
}
</script>
